import React from 'react';
import {useFlag} from '@sail/access';
import {Banner} from '@sail/ui';
import {message, useIntl} from '@sail/intl';
import {FLAGS} from '../utils/flags/flags';

export const messages = {
  title: message({
    id: 'connectEmbed.externalFlagOverrideWrapper.title',
    defaultMessage: 'DEBUG: External flag overrides are being used',
    description: 'Title for the external flag override banner',
  }),
  description: message({
    id: 'connectEmbed.externalFlagOverrideWrapper.description',
    defaultMessage:
      'You are using external flag overrides. This should only be done for testing purposes and real users should never see this flow.',
    description: 'Description for the external flag override banner',
  }),
};

export const ExternalFlagOverrideWrapper: React.FC = ({children}) => {
  const intl = useIntl();

  // FeaturesProvider must be placed under AuthProvider
  const isOverrideFlagInExternalDomainsEnabled = useFlag(
    FLAGS.STRIPE_INTERNAL_OVERRIDE_FLAGS_IN_EXTERNAL_DOMAINS,
  );

  if (!isOverrideFlagInExternalDomainsEnabled) {
    return <>{children}</>;
  }

  return (
    <>
      <Banner
        type="default"
        title={intl.formatMessage(messages.title)}
        description={intl.formatMessage(messages.description)}
        data-testid="external-flag-override-notice-banner"
      />
      <>{children}</>
    </>
  );
};
